import type {
  ICookieConsentResponse,
  ISaveCookieConsentPayload
} from 'types/cookie-consent/cookie-consent.types'

/**
 * TCS-8180: internal consent API service.
 *
 * STUB: the consent API endpoint is not wired yet (the payload contract is
 * already final — see ISaveCookieConsentPayload). These functions are
 * no-ops that resolve immediately so the UI can be built and tested now.
 * When the real endpoints are defined, replace the stub bodies with the
 * actual axios calls (keeping the same signatures) — no other layer needs
 * to change.
 */

/**
 * Persist the user's consent decision server-side.
 * TODO(TCS-8180): replace with the real endpoint once the API spec lands.
 */
export async function saveCookieConsent(
  _payload: ISaveCookieConsentPayload
): Promise<ICookieConsentResponse> {
  // Stub: nothing to send yet. Keep the signature stable for the real call:
  // import { EP } from 'endpoints/endpoints'
  // return axios.post(`${EP.consentApi}/consent`, payload)
  return Promise.resolve({})
}

/**
 * Fetch a previously saved consent decision (cross-device sync, if the API
 * supports it). Returns null when no consent exists for the user.
 * TODO(TCS-8180): replace with the real endpoint once the API spec lands.
 */
export async function getCookieConsent(): Promise<ICookieConsentResponse | null> {
  // Stub: no server-side consent yet.
  // return axios.get(`${EP.consentApi}/consent`)
  return Promise.resolve(null)
}
